import { captureManualException } from "../tracing/sentry";
import { z } from "zod";

const base = `${window.INBOX_REWARDS_BASE}`;

if (!base) {
    captureManualException(new Error("Inbox Rewards API not defined"));
}

if (!("fetch" in window)) {
    captureManualException(new Error("Fetch API not supported"));
}

export const SpellFactoryRewardStatus = z.union([
    z.literal("VOUCHER_REDEEMED"),
    z.literal("VOUCHER_NOT_REDEEMED"),
]);

export const SpellFactoryRewardResponse = z.record(
    z.string(),

    z.object({
        status: SpellFactoryRewardStatus,
    }),
);

export type SpellFactoryRewardResponse = z.infer<
    typeof SpellFactoryRewardResponse
>;

export const getRewardStatus = async (
    voucherIds: string[],
    jwt: string,
): Promise<SpellFactoryRewardResponse | null> => {
    try {
        const params = new URLSearchParams();
        params.set("voucher", voucherIds.join(","));

        const response = await fetch(`${base}/check-status?${params}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${jwt}`,
            },
        });

        const asJson = await response.json();

        const parsed = SpellFactoryRewardResponse.parse(asJson);

        return parsed;
    } catch (error) {
        if (error instanceof Error && !(error instanceof TypeError)) {
            captureManualException(error);
        }
        return null;
    }
};
